/**
 * Когда весь js отработал и страница построилась,
 * показываем её
 */

setTimeout(() => {
    App.H.addClass('_preloaded');
    App.W.trigger('preloaded');
}, 500);



// WEBPACK FOOTER //
// ./_src/js/modules/Preloader.js